import { useEffect } from 'react';
import useGeneralSettingsStore from '../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { useApplicationContext } from '../../../../context/ApplicationContext/ApplicationContext';

interface UseBrandSettingsForStoreExportParams {
  brandId?: string;
  enabled: boolean;
  isOfflineMode: boolean;
}

const useBrandSettingsForStoreExport = ({
  brandId,
  enabled,
  isOfflineMode,
}: UseBrandSettingsForStoreExportParams) => {
  const { isStore, state } = useApplicationContext();
  const fetchGeneralSettings = useGeneralSettingsStore((store) => store.fetchGeneralSettings);
  const clearGeneralSettings = useGeneralSettingsStore((store) => store.clearGeneralSettings);

  const hasSelectedBrand = !!state.brand?.id;

  useEffect(() => {
    if (!enabled || isOfflineMode || !brandId || !isStore || hasSelectedBrand) {
      return;
    }

    fetchGeneralSettings();

    return () => {
      clearGeneralSettings();
    };
  }, [
    brandId,
    enabled,
    isOfflineMode,
    isStore,
    hasSelectedBrand,
    fetchGeneralSettings,
    clearGeneralSettings,
  ]);
};

export default useBrandSettingsForStoreExport;
